import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers';
import { STORAGE_KEY, AD_SUPPRESSED } from './constants';

const localStorage = createLocalStorageProvider(STORAGE_KEY);

export const persistAdPermanentlySuppressed = () => {
	localStorage.set(AD_SUPPRESSED, true);
};

export const shouldShowAd = (): boolean => !localStorage.get(AD_SUPPRESSED);
